import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import {
  SectionContent,
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { AnimatePresence, motion } from "framer-motion";

import FnrFade from "UI/FnrFade/FnrFade";

import { usePaymentForm } from "../PaymentFormContext";

import AddOnGift from "./AddOnGift";

export default function AddOnGiftsSection() {
  const {
    state: { formStages, isSubmitting },
    dispatch: formDispatch,
  } = usePaymentForm();
  const {
    state: { network, selectedPaymentMethodID },
    dispatch,
  } = usePaymentPage();

  const paymentPageData = window?.data?.paymentPageData;
  const addOnGifts = paymentPageData?.addOnGifts || [];
  const hasPaymentMethod = selectedPaymentMethodID > 0;

  if (addOnGifts?.length > 3) addOnGifts.length = 3;

  if (!addOnGifts?.length) return null;

  return (
    <FnrFade show={hasPaymentMethod}>
      {/* <AddOnGiftSectionContent> */}
      {/* <Contents> */}
      {addOnGifts.map((addOnGift) => (
        <Wrapper key={addOnGift.addOnID}>
          <AddOnGiftSectionContent>
            <Contents>
              <AddOnGift addOnGift={addOnGift} />
            </Contents>
          </AddOnGiftSectionContent>
          <WrapperVerticalPadding />
        </Wrapper>
      ))}
      {/* </Contents> */}
      {/* </AddOnGiftSectionContent> */}
      {/* <WrapperVerticalPadding /> */}
    </FnrFade>
  );
}

const Wrapper = styled(motion.div)`
  ${sidePadding}
`;

const AddOnGiftSectionContent = styled(SectionContent)`
  padding: 0;
  overflow: visible;
  //min-height: 74px;
  min-height: 52px;
  position: relative;
`;

const ClickWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 14px;
  &.willNavigateToPaymentMethods {
    cursor: pointer;
  }
`;

const Contents = styled.div`
  flex-grow: 1;
  //padding: 14px;
  padding: 6px;
  margin-bottom: -2px;
  display: flex;
  flex-direction: column;
  //gap: 7px;
`;
